import { useEffect, useState } from 'react'
import moment from "moment";
import {translateService} from "../services/TranslateService";

//copied across to use in the specific functions
const socialSecurityRexExp = /^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])(([5-9]\d\+)|(\d\d[-YXWVU])|([01]\d[ABCDEF]))\d{3}[\dA-Za-z]$/; // NEW SSN FORMAT (Custom RegEx)
const birthDateRegex = /^\s*(3[01]|[12][0-9]|0?[1-9])(1[012]|0?[1-9])((?:19|20)\d{2})\s*$/;
const checkSum = '0123456789ABCDEFHJKLMNPRSTUVWXY'; // for SSN validation
const phoneValidate = new RegExp(/^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/);
const emailValidate = new RegExp("[^@ \\t\\r\\n]+@[^@ \\t\\r\\n]+\\.[^@ \\t\\r\\n]+");

export const useIsCompany = (initialValue: boolean) => {
  const [isCompany, setIsCompany] = useState(initialValue)
  const [isCompanyErrorString, setIsCompanyErrorString] = useState('');
  const [isCompanyErrorOverride, setIsCompanyErrorOverride] = useState(false);

  useEffect(() => {
    if (!isCompanyErrorOverride) {
    } else setIsCompanyErrorString('');
  }, [isCompany, isCompanyErrorOverride])

  return { isCompany, setIsCompany, isCompanyErrorString, setIsCompanyErrorOverride }
}

export const useIsCountryForeign = (initialValue: boolean) => {
  const [isCountryForeign, setIsCountryForeign] = useState(initialValue)
  const [isCountryForeignErrorString, setIsCountryForeignErrorString] = useState('');
  const [isCountryForeignErrorOverride, setIsCountryForeignErrorOverride] = useState(false);

  useEffect(() => {
    if (!isCountryForeignErrorOverride) {
    }
    setIsCountryForeignErrorString('');
  }, [isCountryForeign, isCountryForeignErrorOverride])

  return { isCountryForeign, setIsCountryForeign, isCountryForeignErrorString,
    setIsCountryForeignErrorOverride }
}

export const useValidCompanyName = (initialValue: string, companyNameFieldRef: string) => {
  const [companyName, setCompanyName] = useState(initialValue)
  const [companyNameErrorString, setCompanyNameErrorString] = useState('');
  const [companyNameErrorOverride, setCompanyNameErrorOverride] = useState(false);

  useEffect(() => {
    if (!companyNameErrorOverride) {
      if (companyName.length < 1) {
        setCompanyNameErrorString(translateService.translate('vehicleSearch1.companyNameRequired'))
        return;
      }

      if (companyName.length > 40) {
        setCompanyNameErrorString(translateService.translate('vehicleSearch1.companyNameLong'))
        return;
      }
    }

    setCompanyNameErrorString('');
  }, [companyName, companyNameErrorOverride])

  const handleCompanyNameFieldErr = () => {
    if(companyNameErrorString.length){
      return companyNameFieldRef; // input field component name
    } return null
  }

  return { companyName, setCompanyName, companyNameErrorString, setCompanyNameErrorOverride,
    handleCompanyNameFieldErr, companyNameFieldRef }
}

export const isCompanyNameValid = (companyName: string | undefined) => {
  if (!companyName) return false;

  if(companyName.length < 1 || companyName.length > 40) {
    return false;
  }
  return true; // valid company name
}

export const useValidCompanyId = (initialValue: string, companyIdFieldRef: string) => {
  const [companyId, setCompanyId] = useState(initialValue)
  const [companyIdErrorString, setCompanyIdErrorString] = useState('');
  const [companyIdErrorOverride, setCompanyIdErrorOverride] = useState(false);

  useEffect(() => {
    if (!companyIdErrorOverride) {
      if (companyId.length !== 9) {
        setCompanyIdErrorString(translateService.translate('vehicleSearch1.companyVatId'))
        return;
      }
      // valid example: 5772118-3
      // https://tarkistusmerkit.teppovuori.fi/tarkmerk.htm#y-tunnus2
      let vatModulo = Number(
          Number(companyId[0]) * 7 +
          Number(companyId[1]) * 9 +
          Number(companyId[2]) * 10 +
          Number(companyId[3]) * 5 +
          Number(companyId[4]) * 8 +
          Number(companyId[5]) * 4 +
          Number(companyId[6]) * 2) % 11;

      if (vatModulo){
        vatModulo = 11 - vatModulo
      }

      if (Number(companyId[8]) !== vatModulo || companyId[7] !== "-") { // hyphen mandatory
        setCompanyIdErrorString(translateService.translate('vehicleSearch1.companyVatIdNotValid'))
        return;
      }
      setCompanyIdErrorString('');

    } else setCompanyIdErrorString('');
  }, [companyId, companyIdErrorOverride])

  const handleCompanyIdFieldErr = () => {
    if(companyIdErrorString.length){
      return companyIdFieldRef; // input field component name
    } return null
  }

  return { companyId, setCompanyId, companyIdErrorString, setCompanyIdErrorOverride,
    handleCompanyIdFieldErr, companyIdFieldRef }
}

export const isCompanyVatIdValid = (companyVatId: string | undefined) => {
  // used to validate company id on payment screen
  if (!companyVatId) return false;

  if (companyVatId.length !== 9) return false;

  // valid example: 5772118-3
  // https://tarkistusmerkit.teppovuori.fi/tarkmerk.htm#y-tunnus2
  let vatModulo = Number(
      Number(companyVatId[0]) * 7 +
      Number(companyVatId[1]) * 9 +
      Number(companyVatId[2]) * 10 +
      Number(companyVatId[3]) * 5 +
      Number(companyVatId[4]) * 8 +
      Number(companyVatId[5]) * 4 +
      Number(companyVatId[6]) * 2) % 11;

  if (vatModulo){
    vatModulo = 11 - vatModulo
  }

  if (Number(companyVatId[8]) !== vatModulo || companyVatId[7] !== "-") { // hyphen mandatory
    return false;
  }

  return true; // valid company id

}

export const useValidCompanyRef = (initialValue: string) => {
  const [companyRef, setCompanyRef] = useState(initialValue)
  const [companyRefErrorString, setCompanyRefErrorString] = useState('');
  const [companyRefErrorOverride, setCompanyRefErrorOverride] = useState(false);

  useEffect(() => {
    if (!companyRefErrorOverride) {
      // none
    }

    setCompanyRefErrorString('');
  }, [companyRef, companyRefErrorOverride])

  // no field error handling needed here

  return { companyRef, setCompanyRef, companyRefErrorString, setCompanyRefErrorOverride }
}

export const useValidGivenName = (initialValue: string, givenNameFieldRef: string) => {
  const [givenName, setGivenName] = useState(initialValue)
  const [givenNameErrorString, setGivenNameErrorString] = useState('');

  useEffect(() => {
    if (givenName.length < 1) {
      setGivenNameErrorString(translateService.translate('vehicleSearch1.fieldRequired'))
      return;
    }

    setGivenNameErrorString('');
  }, [givenName])

  const handleGivenNameFieldErr = () => {
    if(givenNameErrorString.length){
      return givenNameFieldRef; // input field component name
    } return null
  }

  return { givenName, setGivenName, givenNameErrorString, handleGivenNameFieldErr, givenNameFieldRef }
}

export const useValidFamilyName = (initialValue: string, familyNameFieldRef: string) => {
  const [familyName, setFamilyName] = useState(initialValue)
  const [familyNameErrorString, setFamilyNameErrorString] = useState('');

  useEffect(() => {
    if (familyName.length < 1) {
      setFamilyNameErrorString(translateService.translate('vehicleSearch1.fieldRequired'))
      return;
    }

    setFamilyNameErrorString('');
  }, [familyName])

  const handleFamilyNameFieldErr = () => {
    if(familyNameErrorString.length){
      return familyNameFieldRef; // input field component name
    } return null
  }

  return { familyName, setFamilyName, familyNameErrorString, handleFamilyNameFieldErr, familyNameFieldRef }
}

export const useValidDateOfBirth = (initialValue: string, dateOfBirthFieldRef: string, noUnderTwentyOnes?: boolean) => {
  const [dateOfBirth, setDateOfBirth] = useState(initialValue)
  const [dateOfBirthErrorString, setDateOfBirthErrorString] = useState('');
  const [dateOfBirthErrorOverride, setDateOfBirthErrorOverride] = useState(false);

  useEffect(() => {
    if (!dateOfBirthErrorOverride) {
      if (dateOfBirth.length === 0) {
        setDateOfBirthErrorString(translateService.translate('vehicleSearch1.fieldRequired'));
        return;
      }

      if (dateOfBirth.length !== 8) {
        setDateOfBirthErrorString( translateService.translate('vehicleSearch1.birthdateFormat'));
        return
      }

      if (birthDateRegex.test(dateOfBirth)){
        let value = dateOfBirth.trim();
        let strValue = String(value);
        let years = moment().diff(strValue.substring(4, 8) + '-' + strValue.substring(2, 4) + '-' + strValue.substring(0, 2), 'years');

        if (noUnderTwentyOnes) {
          if (years < 21) {
            setDateOfBirthErrorString(translateService.translate('vehicleSearch1.translationUnderAge21'));
          } else {
            setDateOfBirthErrorString('');
          }
        } else {
          if (years < 18) {
            setDateOfBirthErrorString( translateService.translate('vehicleSearch1.translationUnderAge18'));
          } else {
            setDateOfBirthErrorString('');
          }
        }
      } else {
        setDateOfBirthErrorString( translateService.translate('vehicleSearch1.birthdateFormat'));
      }
    } else setDateOfBirthErrorString('')

  }, [dateOfBirth, dateOfBirthErrorOverride, noUnderTwentyOnes])

  const handleDateOfBirthFieldErr = () => {
    if(dateOfBirthErrorString.length){
      return dateOfBirthFieldRef; // input field component name
    } return null
  }

  return { dateOfBirth, setDateOfBirth, dateOfBirthErrorString, setDateOfBirthErrorOverride,
    handleDateOfBirthFieldErr, dateOfBirthFieldRef }
}

export const checkBirthdateFromLogin = (dateOfBirth: any) => {
  // note: format check, not an age check
  if (!dateOfBirth) return false;
  if (typeof dateOfBirth === 'object') return false; // safety measure since coming in from external source

  if (dateOfBirth === '' || dateOfBirth.length !== 8) return false;

  if(birthDateRegex.test(dateOfBirth)){
    return true;
  } else {
    return false
  }
}

export const useValidSocialSecurityNum = (initialValue: string, loggedIn: boolean, SSNFieldRef: string,
                                          noUnderTwentyOnes?: boolean, isForeignAndNoBirthDate?: boolean, birthdate?: any) => {
  const [socialSecurityNum, setSocialSecurityNum] = useState(initialValue)
  const [socialSecurityNumErrorString, setSocialSecurityNumErrorString] = useState('');
  const [socialSecurityNumErrorOverride, setSocialSecurityNumErrorOverride] = useState(false);

  // Test cases can be found here: https://dvv.fi/en/reform-of-personal-identity-code

  useEffect(() => {
    if (!socialSecurityNumErrorOverride) { // if ssn needed

      if (loggedIn) { // if customer logged in, SSN has been verified beforehand and stored in BE
        setSocialSecurityNumErrorString('');
        return
      }

      if (socialSecurityNum.length !== 11) {
        setSocialSecurityNumErrorString(translateService.translate('profileCompletenessPhase.errors.validSocialSecurity'));
        return;
      } else {
        let ssnValid = false;
        let ssnChecksum, years;
        let value = socialSecurityNum.trim();

        if(isForeignAndNoBirthDate){
          ssnValid = (socialSecurityRexExp.test(socialSecurityNum));
        }

        let modulo = Number(value.substring(0, 6) + value.substring(7, 10)) % 31;
        if (checkSum.substring(modulo, modulo + 1) !== (value.substring(10, 11)).toUpperCase()) {
          ssnChecksum = false
        } else { ssnChecksum = true }

        if (birthdate && moment(birthdate).isValid()) { // check if valid date else returns "0"
          years = moment().diff(birthdate, 'years');
        } else {
          // calculate age years
          let ssnSeparator = value.substring(6, 7);
          if (ssnSeparator === 'A' || ssnSeparator === 'B' ||ssnSeparator === 'C' ||ssnSeparator === 'D' ||ssnSeparator === 'E' ||ssnSeparator === 'F') { // Born in the 2000's
            years = moment().diff('20' + value.substring(4, 6) + '-' + value.substring(2, 4) + '-' + value.substring(0, 2), 'years');
          } else {
            years = moment().diff('19' + value.substring(4, 6) + '-' + value.substring(2, 4) + '-' + value.substring(0, 2), 'years');
          }
        }

        if (!ssnValid || !ssnChecksum) {
          setSocialSecurityNumErrorString(translateService.translate('vehicleSearch1.translationErrorSocialSecurity'));
          return}
        if (noUnderTwentyOnes && years < 21) {
          setSocialSecurityNumErrorString(translateService.translate('vehicleSearch1.translationUnderAge21'));
          return
        }

        if (years < 18) {
          setSocialSecurityNumErrorString(translateService.translate('vehicleSearch1.translationUnderAge18'));
          return
        }

        setSocialSecurityNumErrorString('');
      }
    }
    else setSocialSecurityNumErrorString('')
  }, [socialSecurityNum, socialSecurityNumErrorOverride, loggedIn, birthdate, isForeignAndNoBirthDate])

  const handleSSNFieldErr = () => {
    if(socialSecurityNumErrorString.length){
      return SSNFieldRef // input field component name
    } return null
  }

  return { socialSecurityNum, setSocialSecurityNum, socialSecurityNumErrorString,
    setSocialSecurityNumErrorOverride, handleSSNFieldErr, SSNFieldRef }
}

export const useValidAddress = (initialValue: string, addressFieldRef: string) => {
  // Tashna
  const [address, setAddress] = useState(initialValue)
  const [addressErrorString, setAddressErrorString] = useState('');

  useEffect(() => {
    if (address.length === 0) {
      setAddressErrorString(translateService.translate('vehicleSearch1.fieldRequired'));
    } else setAddressErrorString('');
  }, [address])

  const handleAddressFieldErr = () => {
    if(addressErrorString.length){
      return addressFieldRef; // input field component name
    } return null
  }

  return { address, setAddress, addressErrorString, handleAddressFieldErr, addressFieldRef }
}

export const useValidCity = (initialValue: string, cityFieldRef: string) => {
  const [city, setCity] = useState(initialValue)
  const [cityErrorString, setCityErrorString] = useState('');

  useEffect(() => {
    if (city.length === 0) {
      setCityErrorString(translateService.translate('vehicleSearch1.fieldRequired'));
    } else setCityErrorString('');
  }, [city])

  const handleCityFieldErr = () => {
    if(cityErrorString.length){
      return cityFieldRef; // input field component name
    } return null
  }

  return { city, setCity, cityErrorString, handleCityFieldErr, cityFieldRef }
}

export const useValidZipCode = (initialValue: string, zipCodeFieldRef: string, foreigner?: boolean ) => {
  const [zipCode, setZipCode] = useState(initialValue)
  const [zipCodeErrorString, setZipCodeErrorString] = useState('');

  useEffect(() => {
    if (zipCode.length === 0) {
      setZipCodeErrorString(translateService.translate('vehicleSearch1.fieldRequired'));
    }
    else {
      if (foreigner) {
        zipCode.length < 2 ? setZipCodeErrorString(translateService.translate('vehicleSearch1.translationErrorPostal'))
            : setZipCodeErrorString('')
      } else {
        zipCode.length !== 5 || !(/^\d+$/.test(zipCode)) ? setZipCodeErrorString(translateService.translate('vehicleSearch1.translationErrorPostal'))
            : setZipCodeErrorString('')
      }
    }
  }, [zipCode, foreigner])

  const handleZipCodeFieldErr = () => {
    if(zipCodeErrorString.length){
      return zipCodeFieldRef; // input field component name
    } return null
  }

  return { zipCode, setZipCode, zipCodeErrorString, handleZipCodeFieldErr, zipCodeFieldRef }
}

export const useValidForeignCountryName = (initialValue: string | null, countryFieldRef: string) => {
  const [foreignCountry, setForeignCountry] = useState(initialValue ?? null)
  const [foreignCountryErrorString, setForeignCountryErrorString] = useState('');
  const [foreignCountryErrorOverride, setForeignCountryErrorOverride] = useState(false);

  useEffect(() => {
    if (!foreignCountryErrorOverride) { // foreign country === false
        if (foreignCountry == null || foreignCountry === '') {
          setForeignCountryErrorString(translateService.translate('vehicleSearch1.fieldRequired'));
        } else setForeignCountryErrorString('');
    }
    else setForeignCountryErrorString('')
  }, [foreignCountry, foreignCountryErrorOverride])

  const handleCountryFieldErr = () => {
    if(foreignCountryErrorString.length){
      return countryFieldRef; // input field component name
    } return null
  }

  return { foreignCountry, setForeignCountry, foreignCountryErrorString,
    setForeignCountryErrorOverride, handleCountryFieldErr, countryFieldRef }
}

export const useEmailConsent = (initialValue: {yes: boolean, no: boolean},
                                emailConsent1FieldRef: string, emailConsent2FieldRef: string) => {
  const [ emailConsent, setEmailConsent ] = useState(initialValue);
  const [ emailConsentErrorString, setEmailConsentErrorString ] = useState('');

  useEffect(() => {
    if(!emailConsent.no && !emailConsent.yes) {
      setEmailConsentErrorString(translateService.translate('vehicleSearch1.selectAbove'));
    } else setEmailConsentErrorString('');
  }, [emailConsent])

  const setEmailConsentInputs = (checked: boolean, radioType: string) => {
    if (radioType === "yes") {
      setEmailConsent({yes: checked, no: !checked})
    } else {
      setEmailConsent({yes: !checked, no: checked})
    }
  }

  const handleEmailConsentCheckErr = () => {
    if(emailConsentErrorString.length){
      return emailConsent1FieldRef; // input field component name
    } return null
  }

  return { emailConsent, setEmailConsentInputs, emailConsentErrorString, handleEmailConsentCheckErr,
    emailConsent1FieldRef, emailConsent2FieldRef}
}

export const useValidPhoneNumber = (initialValue: string, phoneNum1FieldRef: string, phoneNum2FieldRef: string, reEnterPhoneSetFromLogin: string) => {
  const [phoneNumber, setPhoneNumber] = useState<string>(initialValue)
  const [phoneNumber2, setPhone2] = useState<boolean>(false)
  const [phoneNumberErrorString, setPhoneNumberErrorString] = useState<string>("")
  const [reEnterPhone, setReEnterPhone] = useState<string>(reEnterPhoneSetFromLogin)
  const [reEnterPhoneErrorString, setReEnterPhoneErrorString] = useState<string>("")

  useEffect(()=>{
    if(!phoneValidate.test(phoneNumber.replace(' ', '').trim()) || phoneNumber.length > 20){
      setPhoneNumberErrorString(translateService.translate('profileCompletenessPhase.errors.validPhone'))
    } else{
      setPhoneNumberErrorString("")
    }
    if(reEnterPhone === phoneNumber) {
      setReEnterPhoneErrorString("")
      setPhone2(true)
    } else {
      setReEnterPhoneErrorString(translateService.translate('vehicleSearch1.phonerepeat'))
    }

  },[phoneNumber, reEnterPhone])

  const handlePhoneNumFieldErr = () => {
    if(phoneNumberErrorString.length){
      return phoneNum1FieldRef; // input field component name
    }
    if(reEnterPhoneErrorString.length){
      return phoneNum2FieldRef;
    }
    return null
  }

  return {phoneNumber, phoneNumberErrorString, setPhoneNumber, reEnterPhoneErrorString,
    setReEnterPhone, reEnterPhone, phoneNumber2, handlePhoneNumFieldErr,
    phoneNum1FieldRef, phoneNum2FieldRef}
}

export const useValidEmail = (initialValue: string, email1FieldRef: string, email2FieldRef: string, reEnterEmailValue: string) => {
  const [email, setEmail] = useState<string>(initialValue)
  const [reEnterEmail, setReEnterEmail] = useState<string>(reEnterEmailValue || '')
  const [emailErrorString, setEmailErrorString] = useState<string>('')
  const [reEnterEmailErrorString, setReEnterEmailErrorString] = useState<string>('')

  useEffect(() => {
    let trimmedEmail = email.trim();
    if(trimmedEmail.includes(' ') || !emailValidate.test(email)){ // checks from empty spaces between 1st --> last character
      setEmailErrorString(translateService.translate('profileCompletenessPhase.errors.validEmail'));
    } else if (trimmedEmail.includes('.@') || trimmedEmail.includes('@.') ) { // separated test cases so break can occur faster if required
      // test for invalid points before and after @
      setEmailErrorString(translateService.translate('profileCompletenessPhase.errors.validEmail'));
    } else if (trimmedEmail.indexOf('@') !== trimmedEmail.lastIndexOf('@')) {
      // check for duplicated @ character
      setEmailErrorString(translateService.translate('profileCompletenessPhase.errors.validEmail'));
    } else{
      setEmailErrorString("")
    }
    if (reEnterEmail === email) {
      setReEnterEmailErrorString("")
    } else {
      setReEnterEmailErrorString(translateService.translate('vehicleSearch1.emailrepeat'))
    }

  }, [email, reEnterEmail, emailValidate]);

  const handleEmailFieldErr = () => {
    if(emailErrorString.length){
      return email1FieldRef; // input field component name
    }
    if(reEnterEmailErrorString.length){
      return email2FieldRef;
    }
    return null
  }

  return {email, emailErrorString, setEmail, setReEnterEmail, reEnterEmailErrorString, reEnterEmail,
    handleEmailFieldErr, email1FieldRef, email2FieldRef}
}

export const useServiceAgreementValidation = (initialValue:boolean, acceptFieldRefs: string, formSubmitted: boolean) => {
  const [policy, setPolicy] = useState<boolean>(false)
  const [conditions, setConditions] = useState<boolean>(false)
  const [returnAgree, setReturnAgree] = useState<boolean>(false)
  const [liability, setLiability] = useState<boolean>(false)
  const [agree, setAgree] = useState<boolean>(initialValue)
  const [agreeErrorString, setAgreeErrorString] = useState<string>("")

  useEffect(() => {
    if(formSubmitted) {
      if(policy && conditions && returnAgree && liability){
        setAgree(true)
        setAgreeErrorString("")
      } else {
        setAgree(false)
        setAgreeErrorString(translateService.translate('vehicleSearch1.termsAgreeErrorString'))
      }
    }
  }, [policy,conditions,returnAgree,liability,agree, formSubmitted]);

  const handleServiceAgreeCheckErr = () => {
    if(agreeErrorString.length){
      return acceptFieldRefs; // input field component name
      // added first 1 only => error string shows at top of first checkbox
    }
    return null
  }

  return { policy, setPolicy, conditions, setConditions, returnAgree, setReturnAgree,
    liability, setLiability, agree, agreeErrorString, handleServiceAgreeCheckErr, acceptFieldRefs}
}

export const useValidFullName = (initialValue: string, addDriverNameFieldRef: string, overrideAddDriverNameErr: boolean) => {
  const [additionalDriverName, setAdditionalDriverName] = useState(initialValue)
  const [addDriverNameErrorString, setAddDriverNameErrorString] = useState('');

  useEffect(() => {
    if(!overrideAddDriverNameErr) {
      if (additionalDriverName.length < 3) {
        setAddDriverNameErrorString(translateService.translate('vehicleSearch1.fieldRequired'))
        return;
      }
      setAddDriverNameErrorString('');
    } else {
      setAddDriverNameErrorString('');
      if(additionalDriverName.length) {
        setAdditionalDriverName('');
      }
    }
  }, [additionalDriverName, overrideAddDriverNameErr])

  const handleAddDriverNameFieldErr = () => {
    if(addDriverNameErrorString.length){
      return addDriverNameFieldRef; // input field component name
    } return null
  }

  return { additionalDriverName, setAdditionalDriverName, addDriverNameErrorString,
    handleAddDriverNameFieldErr, addDriverNameFieldRef }
}

export const useValidAddDriverNumber = (initialValue: string, addDriverNumFieldRef: string, mainDriverPhoneNumber: string,
                                        overrideAddDriverNumErr: boolean) => {
  const [addDriverNumber, setAddDriverNumber] = useState<string>(initialValue); //  driver phone number
  const [addDriverNumberErrorString, setAddDriverNumberErrorString] = useState<string>("")

  useEffect(()=>{
    if(!overrideAddDriverNumErr) {
      if(!phoneValidate.test(addDriverNumber) || addDriverNumber.length > 20){
        setAddDriverNumberErrorString(translateService.translate('profileCompletenessPhase.errors.validPhone'))
      } else{
        if(isAdditionalNumberDifferent(mainDriverPhoneNumber, addDriverNumber)) { // driver number cannot be same as user number
          setAddDriverNumberErrorString("")
        } else {
          setAddDriverNumberErrorString(translateService.translate('vehicleSearch1.translationEnterDriverPhoneNotSame'))
        }
      }
    } else {
      setAddDriverNumberErrorString("");
      if(addDriverNumber.length) {
        setAddDriverNumber('');
      }
    }
  },[addDriverNumber, mainDriverPhoneNumber, overrideAddDriverNumErr])

  const handleAddDriverNumFieldErr = () => {
    if(addDriverNumberErrorString.length){
      return addDriverNumFieldRef; // input field component name
    }
    return null
  }

  return {addDriverNumber, addDriverNumberErrorString, setAddDriverNumber, handleAddDriverNumFieldErr,
    addDriverNumFieldRef}
}

const isAdditionalNumberDifferent = (mainPhoneNumber: string, additionalPhoneNumber: string) => {
  // function checks all possible cases to enter the same number
  // (note: if number starts with 0, it is considered Finnish with a country code of '+358')

  if (mainPhoneNumber === additionalPhoneNumber) { return false } // exact match

  // For Finnish numbers:
  if (mainPhoneNumber.substring(0, 4) === "+358" || mainPhoneNumber.substring(0, 1) === "0") {
    if(additionalPhoneNumber.substring(0, 1) === "0") { // look for +3580 and +358...
      let mainNumWithoutCode = mainPhoneNumber.slice(4);
      if (mainNumWithoutCode === additionalPhoneNumber  // (m: +358077, a: 077)
          || ('0' + mainNumWithoutCode) === additionalPhoneNumber // (m: +35877, a: 077)
      ) {
        return false;
      }
    }

    if(additionalPhoneNumber.substring(0, 4) === "+358") {
      let additionalNumWithoutCode = additionalPhoneNumber.slice(4);
      let mainNumWithoutCode = mainPhoneNumber.slice(4);
      if (additionalNumWithoutCode === mainPhoneNumber // (m: 077, a: +358077)
          || ('0' + additionalNumWithoutCode) === mainPhoneNumber // (m: 077, a: +35877)
          || (additionalNumWithoutCode === ('0' + mainNumWithoutCode)) // (m: +35877, a: +358077)
          || (additionalNumWithoutCode === (mainNumWithoutCode.slice(1))) // (m: +358077, a: +35877)
      ) {
        return false;
      }
    }
  }

  // For international numbers:
  if( additionalPhoneNumber.length === mainPhoneNumber.length+1 || additionalPhoneNumber.length === mainPhoneNumber.length-1) {
    let longerNumber;
    let shorterNumber;
    if(additionalPhoneNumber.length > mainPhoneNumber.length) {
      longerNumber = additionalPhoneNumber;
      shorterNumber = mainPhoneNumber;
    } else {
      longerNumber = mainPhoneNumber;
      shorterNumber = additionalPhoneNumber;
    }

    let longerNumFromZero = longerNumber.substring(longerNumber.indexOf('0'));
    if (longerNumFromZero.substring(0,1) === '0') {
      let shorterNumberSuffix = shorterNumber.slice(-(longerNumFromZero.length-1)); // just the numbers that could possibly match
      if (shorterNumberSuffix === longerNumFromZero.substring(1)) {
        let longerNumCountryCode = longerNumber.substring(0, longerNumber.indexOf('0'));
        let shortNumCountryCode = shorterNumber.substring(0, longerNumCountryCode.length);
        if (longerNumCountryCode === shortNumCountryCode) {
          return false;
        }
      }
    }
  }
  return true; // numbers different
}

